'use strict'

/**
 * store contains api object which is differ on product and special process
 */
const state = {
  invitesAPI: null,
  responseAPI: null
}

const getters = {
  invitesAPI (state) {
    return state.invitesAPI
  },

  responseAPI (state) {
    return state.responseAPI
  }
}

const actions = {
  setInvitesAPI ({commit}, apiObj) {
    commit('setInvitesAPI', apiObj)
  },
  setResponseAPI({commit}, apiObj) {
    commit('setResponseAPI', apiObj)
  }
}

const mutations = {
  setInvitesAPI (state, apiObj) {
    state.invitesAPI = apiObj
  },
  setResponseAPI(state, apiObj) {
    state.responseAPI = apiObj
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
